/**
 * The exercise catalog: what the Exercise type field picks from.
 *
 * Its own file rather than a function on `exercisePlansService`, the way the
 * meal module keeps its catalogs beside the plans they are picked for: this
 * one is cached for the session and read by a dialog, and the plans it is
 * picked into are fetched per page.
 */

import { api, API_ENDPOINTS } from "../../../lib/api";
import type { GetToken } from "../../auth/types/auth.types";
import type {
  ExerciseTypeOption,
  ExerciseTypesResponse,
} from "../types/exercisePlans.types";

export async function fetchExerciseTypes(
  getToken: GetToken,
  signal?: AbortSignal
): Promise<ExerciseTypeOption[]> {
  const token = await getToken();
  if (!token) {
    throw new Error("No active Clerk session - cannot load exercise types.");
  }

  const response = await api.get<ExerciseTypesResponse>(
    API_ENDPOINTS.catalog.exerciseTypes,
    { token, signal }
  );

  // Rows without a usable name are dropped rather than shown: an empty option
  // is a dead line in the list, and one nothing could ever be picked from.
  return (response?.exercise_types ?? [])
    .filter((row) => typeof row?.name === "string" && row.name.trim())
    .map((row) => ({ id: row.id, name: row.name.trim() }));
}
